import { Orientation, type SerializedDockview } from 'dockview';
import type { TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF } from '../../../Layout/tokens';

const PANELS: Record<string, TypedGroupviewPanelState> = {
  fundingRateHistory: {
    id: 'fundingRateHistory',
    contentComponent: 'historicalFundingRate',
    title: 'Funding Rate History (USD Aggregated)',
    params: { type: 'historicalFundingRate', cmAssetId: 'btc' },
  },
  fundingRateList: {
    id: 'fundingRateList',
    contentComponent: 'fundingRateBlotter',
    title: 'Funding Rate - List (USD Aggregated)',
    params: { type: 'fundingRateBlotter', defaultView: 'List' },
  },
  fundingRateMatrix: {
    id: 'fundingRateMatrix',
    contentComponent: 'fundingRateBlotter',
    title: 'Funding Rate - Matrix (USD Aggregated)',
    params: { type: 'fundingRateBlotter', defaultView: 'Matrix' },
  },
};

const GRID: SerializedDockview['grid'] = {
  root: {
    type: BRANCH,
    data: [
      {
        type: LEAF,
        visible: true,
        data: { views: ['fundingRateHistory'], activeView: 'fundingRateHistory', id: 'fundingRateHistory' },
        size: 450,
      },
      {
        type: BRANCH,
        data: [
          {
            type: LEAF,
            visible: true,
            data: { views: ['fundingRateList'], activeView: 'fundingRateList', id: 'fundingRateList' },
            size: 800,
          },
          {
            type: LEAF,
            visible: true,
            data: { views: ['fundingRateMatrix'], activeView: 'fundingRateMatrix', id: 'fundingRateMatrix' },
            size: 800,
          },
        ],
        size: 450,
      },
    ],
    size: 900,
  },
  width: 1600,
  height: 900,
  orientation: Orientation.VERTICAL,
};

export const INTEL_FUNDING_RATES_LAYOUT: SerializedDockview = {
  grid: GRID,
  panels: PANELS,
};
